import { catchError } from 'rxjs/operators';
import { EnvService } from './../../services/env.service';

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ISetUpPasswordRequest, ISetUpPasswordResetRequest, ISetUpPasswordResponse, ResetPasswordResponse } from "../model/setUpPassword.model";


@Injectable()
export class SetUpPasswordService {
  constructor(private http: HttpClient, private env: EnvService) {}

  postPasswordData(passwordRequest: ISetUpPasswordRequest): Observable<ISetUpPasswordResponse> {
    const baseUrl = this.env.apiBaseUrls;
    let url = `${baseUrl}/account/claim_process`;
    let options = {headers: new HttpHeaders({'Content-Type':'application/json'})} 
    return this.http.post<ISetUpPasswordResponse>(url, passwordRequest,options)
    .pipe(catchError(this.handleError<ISetUpPasswordResponse>('postPasswordData')))
  }

  postResetPasswordData(passwordRequest: ISetUpPasswordResetRequest): Observable<ResetPasswordResponse> {
    const baseUrl = this.env.apiBaseUrls;
    let url = `${baseUrl}/account/reset_password`;
    let options = {headers: new HttpHeaders({'Content-Type':'application/json'})} 
    let response =  this.http.post<ResetPasswordResponse>(url, passwordRequest,options)
    .pipe(catchError(this.handleError<ResetPasswordResponse>('postPasswordResetData')))

    // console.log(response)
    return response
  }

  private handleError<T> (operation ='operation', result?:T){
    return (error: any): Observable<T> => {
      if('error' in error) {
        if( 'exception' in error.error){
          return of(error as T)
        }
      }
      // console.log(result)
      return of(result as T)
    }
  }
}
